import { IDocumentReference } from '@/types/document-reference'
import {
  ILandingPageWithPartner,
  SupportedPartner,
} from '@/types/landing-pages'
import { createContext, ReactNode, useContext } from 'react'

export type MinimalPartnerInfo = Pick<
  SupportedPartner,
  'name' | 'logoUrl' | '_id'
>

interface PartnerInfoContextType {
  partnerInfo: IDocumentReference<MinimalPartnerInfo>
}

const PartnerInfoContext = createContext<PartnerInfoContextType | undefined>(
  undefined
)

interface PartnerInfoProviderProps {
  partnerInfo: IDocumentReference<MinimalPartnerInfo>
  children: ReactNode
}

export function PartnerInfoProvider({
  partnerInfo,
  children,
}: PartnerInfoProviderProps) {
  return (
    <PartnerInfoContext.Provider value={{ partnerInfo }}>
      {children}
    </PartnerInfoContext.Provider>
  )
}

export function usePartnerInfo() {
  const context = useContext(PartnerInfoContext)

  if (!context) {
    return { partnerInfo: { documentType: 'company' } }
  }

  return context
}

type WithLandingPageProps = {
  landingPage: ILandingPageWithPartner
}

export function withPartnerInfo<T extends WithLandingPageProps>(
  Component: React.ComponentType<T>
) {
  return function ComponentWithPartnerInfo(props: T) {
    return (
      <PartnerInfoProvider partnerInfo={props.landingPage.partner}>
        <Component {...props} />
      </PartnerInfoProvider>
    )
  }
}

